import React from 'react';
import { Rescue } from './Rescue';

export default function RescueContainer() {
  return <Rescue />;
}
